module.exports = __webpack_public_path__ + "static/media/adrian.f1234b79.jpg";